export const GET_COMPLIANCE_REQUEST = "GET_COMPLIANCE_REQUEST";
export const GET_COMPLIANCE_SUCCESS = "GET_COMPLIANCE_SUCCESS";
export const GET_COMPLIANCE_FAILURE = "GET_COMPLIANCE_FAILURE";

export const GET_DELETE_COMPLIANCE_REQUEST = "GET_DELETE_COMPLIANCE_REQUEST";
export const GET_DELETE_COMPLIANCE_SUCCESS = "GET_DELETE_COMPLIANCE_SUCCESS";
export const GET_DELETE_COMPLIANCE_FAILURE = "GET_DELETE_COMPLIANCE_FAILURE";


export const CREATE_COMPLIANCE_REQUEST = "CREATE_COMPLIANCE_REQUEST";
export const CREATE_COMPLIANCE_SUCCESS = "CREATE_COMPLIANCE_SUCCESS";
export const CREATE_COMPLIANCE_FAILURE = "CREATE_COMPLIANCE_FAILURE";

export const EDIT_COMPLIANCE_REQUEST = "EDIT_COMPLIANCE_REQUEST";
export const EDIT_COMPLIANCE_SUCCESS = "EDIT_COMPLIANCE_SUCCESS";
export const EDIT_COMPLIANCE_FAILURE = "EDIT_COMPLIANCE_FAILURE";



export const UPLOAD_COMPLIANCE_REQUEST = "UPLOAD_COMPLIANCE_REQUEST";
export const UPLOAD_COMPLIANCE_SUCCESS = "UPLOAD_COMPLIANCE_SUCCESS";
export const UPLOAD_COMPLIANCE_FAILURE = "UPLOAD_COMPLIANCE_FAILURE";

